import PropTypes from 'prop-types';

// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getPreviousRepliesHtml, getPreviousRepliesPlainText
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error module not typed
import ContentText from '../primary-message/ContentText';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageReplies = ({
  isPlainText,
  message
}) => {
  const plainTextContent = getPreviousRepliesPlainText(message);
  const richTextContent = getPreviousRepliesHtml(message);
  const contentText = isPlainText && !!plainTextContent ? plainTextContent : richTextContent;
  if (!contentText || contentText.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ContentText, {
    contentText: contentText,
    isPlainText: isPlainText && plainTextContent,
    dataTestId: "email-message-replies",
    isShowingMessageReplies: true
  });
};
MessageReplies.displayName = 'MessageReplies';
MessageReplies.propTypes = {
  isPlainText: PropTypes.bool.isRequired,
  message: PropTypes.oneOfType([RecordPropType('CommonMessage'), RecordPropType('WorkflowGeneratedUserMessage')]).isRequired
};
export default MessageReplies;